import React, { useEffect, useState } from "react";
import { Edit, SimpleForm, TextInput, SelectInput, required, TopToolbar, Button, useRedirect, DateInput, AutocompleteInput, useNotify, RadioButtonGroupInput, useGetOne, FileInput, FileField } from "react-admin";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Divider, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { cleanTimeChoices, getNameAndCompanyNamewithAddress} from "../common";

const CleanReceptHistoryEdit = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const { id } = useParams(); 
  const [customers,setCustomers]=useState([]);
  const [customerId,setCustomerId]=useState(null);
  const { data, isLoading } = useGetOne("cleanReceptHistory", { id });
  const [isComplete,setIsComplete] = useState(0);

  useEffect(()=>{
    if(!isLoading){
      setCustomerId(data.customerId);
      setIsComplete(data.isComplete)
    }
  },[isLoading])

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/clean`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, marginBottom:-2 }}>
        <TopToolbar>
            <Button
                label="受付情報表示"
                onClick={() => redirect(`/cleanReceptHistory/show/${id}`)}
                startIcon={<VisibilityIcon />}
            />
        </TopToolbar>
    </Box>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Edit mutationMode="pessimistic"
          mutationOptions={{ 
            onSuccess: () => {
              notify('更新が完了しました', { type: 'success' }); 
              // redirect('list', 'cleanReceptHistory');
              window.history.back();
            }
          }}
        >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
          <AutocompleteInput
            source="customerId"
            label="顧客名"
            choices={customers.map(req => ({
              id: req.id, 
              name: `${getNameAndCompanyNamewithAddress(req)}`
            }))}
            onChange={(e) => setCustomerId(e)}
            validate={required()}
            allowEmpty
            freeSolo  
          />
          <DateInput source="receptDate" label="受付日" inputProps={{ max: '9999-12-31' }}/>
          <TextInput source="content" label="受付内容" multiline rows={5}/>
          <RadioButtonGroupInput
            source="isComplete"
            label="清掃予定"
            choices={[
              { id: 1, name: '予定済み' },
              { id: 0, name: '未予定' }
            ]}
            defaultValue={isComplete}
            validate={required()}
            onChange={(e) => {
              console.log(Number(e.target.value));
              setIsComplete(Number(e.target.value))
            }}
          />
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
            <DateInput source="exCleaningDate" label="清掃予定日" style={{marginRight:"10px"}} disabled={!isComplete} inputProps={{ max: '9999-12-31' }}/>
            <SelectInput 
              source="exCleaningTime"
              label="清掃予定時間"
              choices={cleanTimeChoices}
              style={{marginLeft:"10px",marginRight:"10px"}}
              disabled={!isComplete}
            />
            <SelectInput 
              source="district"
              label="地区を選択"
              choices={[
                { id: "A地区", name: "A地区" },
                { id: "B地区", name: "B地区" }
              ]}
              style={{marginLeft:"10px",marginRight:"10px"}}
              disabled={!isComplete}
            />
            <TextInput source="exPumpingAmount" label="汲取予定量(㎥)" type="number" style={{marginLeft:"10px"}} disabled={!isComplete}/>
          </div>         
        </SimpleForm>
      </Edit>
    </>
  )

};

export default CleanReceptHistoryEdit;
